module.exports = __webpack_public_path__ + "static/img/eightab.95e03b1e.png";